import React, { FunctionComponent } from "react";

import { partTypeWheel } from "../../../constants/partTypes";
import { WheelPartItem } from "../../../queries/useSearchWheelsByVehicle";
import { getDefaultQuantity } from "../../PriceSelect/getDefaultQuantity";
import { usePriceSelectState } from "../../PriceSelect/usePriceSelectState";
import { usePricing } from "../../PriceSelect/usePricing";
import { Image } from "../Common/Image";
import { Actions } from "../Common/LeadForm/Actions";
import { PricingNote } from "../Common/PricingNote";
import { WheelSpec } from "./WheelSpec";

type WheelDetailsProps = {
  part: WheelPartItem | null;
};

export const WheelDetails: FunctionComponent<WheelDetailsProps> = ({
  part,
}) => {
  const [priceEntries, setPriceEntries] = usePriceSelectState([]);

  usePricing({
    defaultQuantity: getDefaultQuantity({
      isStaggered: false,
      orderItem: null,
      part,
    }),
    isStaggered: false,
    onReady: setPriceEntries,
    part,
  });

  return (
    <div className="grid md:grid-cols-3 gap-4">
      <main className="flex flex-col gap-4 md:col-span-2">
        <Image part={part} />
        <WheelSpec part={part} />
        <PricingNote partType={partTypeWheel} />
      </main>
      <aside className="flex flex-col gap-4">
        <Actions
          isStaggered={false}
          part={part}
          priceEntries={priceEntries}
          setPriceEntries={setPriceEntries}
        />
      </aside>
    </div>
  );
};
